import React, { useState, useEffect } from "react";  
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import { customStyles } from "../Utility/Utility";
import swal from "sweetalert";
import Loader from "../Loader/Loader";

const MarketingContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [postModal, setPostModal] = useState(false);
  const [formData, setFormData] = useState({
    ContactNumber: "",
    WhatsAppVerify: false,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [verifyMode, setVerifyMode] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const[sendmessagemodel,setsendmessagemodel]=useState(false);
   const [formData1, setFormData1] = useState({
      Name: "",
      Details: "",
    });
     const [data, setData] = useState([]);
     const[startid,setStartId]=useState("");
     const [endid,setEndId]=useState("");
     const [appName, setAppName] = useState("");

     const [selectAll, setSelectAll] = useState(false);
     const [currentPageRows, setCurrentPageRows] = useState([]);
     const [searchMobile, setSearchMobile] = useState("");




  const fetchContacts = async () => {
     setLoading(true);
    
    try {
    const res = await AddUpdate(
      "MarketingContacts/GetData_MarketingContacts",
      { IdFrom: startid, IdTo: endid, AppName: appName ,ContactNumber:searchMobile }
    );

    if (res?.data?.data) {
      try {
        const parsed = JSON.parse(res.data.data);
        setContacts(parsed?.Table || []);
      } catch {
        setContacts([]); 
      }
    } else {
      setContacts([]); 
    }
  } 
    
    
    catch (error) {
      console.error("Error fetching contacts:", error);
    }
    finally{
      setLoading(false);
    }
  };

useEffect(() => {

   fetchContacts();
}, []);





const searchfunction=()=>{
fetchContacts()
}
   const fetchData = async () => {
    setLoading(true);
    try {
      const res = await AddUpdate("Categorydetails/GetData_Categorydetails", {
        IsActive: true,
      });
      if (res?.data?.data) {
        const parsed = JSON.parse(res.data.data);
        setData(parsed?.Table || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sendmessagemodel) fetchData();
  }, [sendmessagemodel]);

  
  const handleNameChange = (e) => {
    const selectedName = e.target.value;
    setFormData1((prev) => ({
      ...prev,
      Name: selectedName,
    }));

    const selectedCategory = data.find((item) => item.Name === selectedName);
    if (selectedCategory) {
      setFormData1({
        Name: selectedCategory.Name,
        Details: selectedCategory.Details || "",
      });
    } else {
      setFormData1({ Name: selectedName, Details: "" });
    }
  };


  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData1((prev) => ({ ...prev, [name]: value }));
  };


  const handleAdd = () => {
    setIsEdit(false);
    setFormData({
      ContactNumber: "",
      WhatsAppVerify: false,
    });
    setPostModal(true);
  };


  const handleEdit = (contact) => {
    setIsEdit(true);
    setSelectedId(contact?.MarketingContactsID);
    setFormData({
      ContactNumber: contact.ContactNumber,
      WhatsAppVerify: false,
    });
    setPostModal(true);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

      if (name === "ContactNumber") {
    if (!/^\d*$/.test(value)) return;   
  }
const maxlenth=isEdit ? 12 : 10;

if (name === "ContactNumber" && value.length > maxlenth) {
    return; 
  }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    let contactNum = formData.ContactNumber.trim();

    if (!contactNum) {
      swal("Missing Contact", "Please enter a contact number.", "warning");
      return;
    }


    if (!contactNum.startsWith("91")) {
      contactNum = "91" + contactNum;
    }

    const apiUrl = isEdit
      ? "MarketingContacts/Update_MarketingContacts"
      : "MarketingContacts/Insert_MarketingContacts";

    const payload = isEdit
      ? { MarketingContactsID: selectedId, ...formData, ContactNumber: contactNum }
      : { ...formData, ContactNumber: contactNum };

    try {
      const res = await AddUpdate(apiUrl, payload);
      if (res?.data?.Status === true || res?.status === 200) {
        swal( "Success",isEdit ? "Contact updated successfully!" : "Contact added successfully!","success");
        setPostModal(false);
        fetchContacts();
      } else {
        swal("Error","Something went wrong.","error");
      }
    } catch (error) {
      console.error("Error saving contact:", error);
    }
  };

  const handleVerifyMode = () => {
    setVerifyMode(!verifyMode);
    setSelectedContacts([]);
  };


  const handleCheckboxChange = (contactNumber) => {
    setSelectedContacts((prev) =>
      prev.includes(contactNumber)
        ? prev.filter((num) => num !== contactNumber)
        : [...prev, contactNumber]
    );
  };

const opendsendmodel=()=>{
   setsendmessagemodel(true)
}


 
  const handleVerifySelected = async (e) => {
    e.preventDefault();
    setsendmessagemodel(true)
    if (selectedContacts.length === 0) {
      swal("Warning","Please select at least one number to send message.","warning");
      return;
    }

    setLoading(true);

// try{

//  const res=await AddUpdate("WhatsApp/SendMessage",{phoneNumbers:selectedContacts,"MessageText":formData1.Name})
 
    
//      swal("Success!", "Message sent successfully!", "success");

//      fetchContacts();
//      setVerifyMode(false);


   
//     }    
  try {
  const res = await AddUpdate("WhatsApp/SendMessage", {
    phoneNumbers: selectedContacts,
    MessageText: formData1.Name,
  });


  let raw = res.data.data || "";


  raw = raw.replace("Details:", "");


  let details;

  try {
    details = JSON.parse(raw);
  } catch (e) {
    
    details = JSON.parse(JSON.parse(JSON.stringify(raw)));
  }

  const item = details[0];

 

  if (item.response) {
    swal("Success!", "Message sent successfully!", "success");
    fetchContacts();
    setVerifyMode(false);
  } 
  else if (item.error) {
    swal("Error!", item.error, "error");
  } 
  else {
    swal("Error!", "Unknown response received!", "error");
  }

} catch (error) {
  swal("Error!", "Something went wrong while sending message!", "error");
}

finally {
      setLoading(false);
      setsendmessagemodel(false);
    }
  };

 
  const columns = [
    {
      name: "Id",
      selector: (row) => row.Id,
      width: "80px",
    },
    {
      name: "Contact Number",
      selector: (row) => row.ContactNumber,
      sortable: true,
    },
    {
      name: "App Name",
      selector: (row) => row.AppName,
      sortable: true,
    },
    {
      name: "WhatsApp Verified",
      selector: (row) => (row.WhatsAppVerify ? " Yes" : " No"),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-sm btn-warning"
          onClick={() => handleEdit(row)}
          style={{ backgroundColor: '#f7931e',color:'black' }}
        >
          Edit
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];


const columnsWithCheckbox = verifyMode
  ? [
      {
        name: (
          <input
            type="checkbox"
            checked={selectAll}
            onChange={(e) => toggleSelectAll(e.target.checked)}
          />
        ),
        width: "70px",
        cell: (row) => (
          <input
            type="checkbox"
            checked={selectedContacts.includes(row.ContactNumber)}
            onChange={() => handleCheckboxChange(row.ContactNumber)}
          />
        ),
      },
      ...columns,
    ]
  : columns;



const toggleSelectAll = (checked) => {
  setSelectAll(checked);

  if (checked) {
    const numbers = currentPageRows.map((x) => x.ContactNumber);
    setSelectedContacts((prev) => [...new Set([...prev, ...numbers])]);
  } else {
    const numbers = currentPageRows.map((x) => x.ContactNumber);
    setSelectedContacts((prev) =>
      prev.filter((num) => !numbers.includes(num))
    );
  }
};

useEffect(() => {
  setCurrentPageRows(contacts.slice(0, 50)); 
}, [contacts]);




  return (    
    <>
      <div className="container mt-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Marketing Contacts</h2>

          
      
      
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: "12px",
    backgroundColor: "#f8f9fa",
    padding: "15px 20px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    marginBottom: "20px",
  }}
>
  {/* Start ID input */}
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <label
      style={{
        fontWeight: "600",
        color: "#002b5c",
        fontSize: "15px",
        minWidth: "45px",
      }}
    >
      Start
    </label>
    <input
      type="number"
      value={startid}
      onChange={(e) => setStartId(e.target.value)}
      placeholder="Enter start number"
      style={{
        padding: "8px 10px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        width: "150px",
        fontSize: "14px",
        outline: "none",
        transition: "border-color 0.3s",
      }}
      onFocus={(e) => (e.target.style.borderColor = "#002b5c")}
      onBlur={(e) => (e.target.style.borderColor = "#ccc")}
    />
  </div>

  {/* End ID input */}
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <label
      style={{
        fontWeight: "600",
        color: "#002b5c",
        fontSize: "15px",
        minWidth: "35px",
      }}
    >
      End
    </label>
    <input
      type="number"
      onChange={(e) => setEndId(e.target.value)}
      placeholder="Enter end number"
      value={endid}
      style={{
        padding: "8px 10px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        width: "150px",
        fontSize: "14px",
        outline: "none",
        transition: "border-color 0.3s",
      }}
      onFocus={(e) => (e.target.style.borderColor = "#002b5c")}
      onBlur={(e) => (e.target.style.borderColor = "#ccc")}
    />
  </div>


 <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <label
      style={{
        fontWeight: "600",
        color: "#002b5c",
        fontSize: "15px",
        minWidth: "80px",
      }}
    >
      App Name
    </label>
    <select
      onChange={(e) => setAppName(e.target.value)}
      style={{
        padding: "8px 10px",
        border: "1px solid #ccc",
        borderRadius: "6px",
        width: "160px",
        fontSize: "14px",
        outline: "none",
        backgroundColor: "#fff",
        cursor: "pointer",
        transition: "border-color 0.3s",
      }}
      onFocus={(e) => (e.target.style.borderColor = "#002b5c")}
      onBlur={(e) => (e.target.style.borderColor = "#ccc")}
    >
      <option value="">select</option>
      <option value="1"> Old AstroCall</option>
      <option value="0">Lottery</option>
    </select>
  </div>



<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  <label
    style={{
      fontWeight: "600",
      color: "#002b5c",
      fontSize: "15px",
      minWidth: "80px",
    }}
  >
    Mobile
  </label>

  <input
    type="number"
    value={searchMobile}
    onChange={(e) => setSearchMobile(e.target.value)}
    placeholder="Enter mobile no."
    style={{
      padding: "8px 10px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      width: "150px",
      fontSize: "14px",
      outline: "none",
      transition: "border-color 0.3s",
    }}
    onFocus={(e) => (e.target.style.borderColor = "#002b5c")}
    onBlur={(e) => (e.target.style.borderColor = "#ccc")}
  />
</div>



 
  <button
    className="btn btn-primary"
    style={{
      backgroundColor: "#002b5c",
      border: "none",
      color: "#fff",
      padding: "8px 18px",
      borderRadius: "6px",
      fontWeight: "600",
      cursor: "pointer",
      fontSize: "14px",
      transition: "0.3s",
    }}
    onClick={searchfunction}
    onMouseOver={(e) => (e.target.style.backgroundColor = "#004080")}
    onMouseOut={(e) => (e.target.style.backgroundColor = "#002b5c")}
  >
    Search
  </button>

 
  <button
    className="btn btn-primary"
    style={{
      backgroundColor: "#f7931e",
      border: "none",
      color: "#000",
      padding: "8px 18px",
      borderRadius: "6px",
      fontWeight: "600",
      cursor: "pointer",
      fontSize: "14px",
      transition: "0.3s",
    }}
    onClick={handleAdd}
    onMouseOver={(e) => (e.target.style.backgroundColor = "#e6891a")}
    onMouseOut={(e) => (e.target.style.backgroundColor = "#f7931e")}
  >
    Add Contact
  </button>


  <button
    className={`btn ${verifyMode ? "btn-warning" : "btn-success"}`}
    style={{
      backgroundColor: verifyMode ? "#ffc107" : "#198754",
      border: "none",
      color: "#000",
      padding: "8px 18px",
      borderRadius: "6px",
      fontWeight: "600",
      cursor: "pointer",
      fontSize: "14px",
      transition: "0.3s",
    }}
    onClick={handleVerifyMode}
    onMouseOver={(e) =>
      (e.target.style.backgroundColor = verifyMode ? "#e0a800" : "#157347")
    }
    onMouseOut={(e) =>
      (e.target.style.backgroundColor = verifyMode ? "#ffc107" : "#198754")
    }
  >
    {verifyMode ? "Cancel Message" : "Send Message"}
  </button>


  {verifyMode && (
    <button
      className="btn btn-primary"
      style={{
        backgroundColor: "#0d6efd",
        border: "none",
        color: "#fff",
        padding: "8px 18px",
        borderRadius: "6px",
        fontWeight: "600",
        cursor: "pointer",
        fontSize: "14px",
        transition: "0.3s",
      }}
      onClick={opendsendmodel}
      disabled={loading}
      onMouseOver={(e) => (e.target.style.backgroundColor = "#0b5ed7")}
      onMouseOut={(e) => (e.target.style.backgroundColor = "#0d6efd")}
    >
      {loading ? "Verifying..." : "Send Message"}
    </button>
  )}
</div>

        </div>

      {
        loading ? (<Loader />):(<DataTable
          columns={columnsWithCheckbox}
          data={contacts || []}
          pagination
          highlightOnHover
          paginationPerPage={50}                   
          paginationRowsPerPageOptions={[25,50, 100]} 
          dense
          customStyles={customStyles}
          noDataComponent="No contacts found"
         onChangePage={(page) => {
  const start = (page - 1) * 50;
  const end = start + 50;
  setCurrentPageRows(contacts.slice(start, end));
  setSelectAll(false);
}}

onChangeRowsPerPage={(newPerPage, page) => {
  const start = (page - 1) * newPerPage;
  const end = start + newPerPage;
  setCurrentPageRows(contacts.slice(start, end));
  setSelectAll(false);
}}


        />)
      }
        
      </div>

      
      <Modal
        show={postModal}
        onHide={() => setPostModal(false)}
        backdrop="static"
        centered
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-header">
            <h4 className="modal-title fs-20">
              {isEdit ? "Update Contact" : "Add Contact"}
            </h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => setPostModal(false)}
            ></button>
          </div>

          <div className="modal-body p-3">
            <div className="form-group mb-3">
              <label>
                Contact Number <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="ContactNumber"
                value={formData.ContactNumber}
                onChange={handleChange}
                autoComplete="off"
                placeholder="Enter mobile number"
              
              />
            </div>
          </div>

          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">
              {isEdit ? "Update" : "Save"}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setPostModal(false)}
            >
              Close
            </button>
          </div>
        </form>
      </Modal>



<Modal
      show={sendmessagemodel}
      onHide={() => setsendmessagemodel(false)}
      backdrop="static"
      centered
      onSubmit={handleVerifySelected}
    >
      <form>
        <div className="modal-header">
          <h4 className="modal-title">Send Message</h4>
          <button
            type="button"
            className="btn-close"
            onClick={() => setsendmessagemodel(false)}
          ></button>
        </div>

        <div className="modal-body">
          
          <div className="mb-3">
            <label className="form-label">
              Name <span className="text-danger">*</span>
            </label>
            <select
              name="Name"
              className="form-select"
              value={formData1.Name}
              onChange={handleNameChange}
              disabled={loading}
            >
              <option value="">-- Select Category --</option>
              {data.map((item) => (
                <option key={item.Id} value={item.Name}>
                  {item.Name}
                </option>
              ))}
            </select>
          </div>

      
          <div className="mb-3">
            <label className="form-label">Details<span className="text-danger">*</span></label>
            <textarea
              name="Details"
              className="form-control"
              readOnly={true}
              rows={3}
              value={formData1.Details}
              onChange={handleChange2}
            ></textarea>
          </div>
        </div>

        <div className="modal-footer">
          <button type="submit" className="btn btn-primary">
            Send
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setsendmessagemodel(false)}
          >
            Close
          </button>
        </div>
      </form>
    </Modal>

    </>
  );
};

export default MarketingContacts;
